import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2544f844"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex align-items-center" }

import { computed, onMounted, ref } from 'vue';
import { CROSS_CHAIN_NETWORK_LIST_DROPDOWN_OPTIONS } from '@/constants/NETWORK_PARAMS';
import { DEFAULT_NETWORK_ID } from '@/helpers/networkParams.helper';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { isFakeCardanoChainId } from '@/helpers/fakeCardanoNetwork';
import { WRAPPED_MILKOMEDA_CARDANO_NETWORK_NAME } from '@/constants/NETWORK_NAMES';
import { checkIfNetworkIdDisabledToAdd } from '@/helpers/network-disable.helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'CrossChainNetworkListDropdown',
  props: {
    buttonText: { type: Boolean },
    defaultChainId: null,
    isReadonly: { type: Boolean }
  },
  emits: ["onChange", "onHide"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onChange', value: number): void;
  (e: 'onHide'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  buttonText?: boolean;
  defaultChainId?: number;
  isReadonly?: boolean;
}



const netsDropdown = ref();

const selectedNetwork = ref();
const networkListOptions = computed(() => {
  return CROSS_CHAIN_NETWORK_LIST_DROPDOWN_OPTIONS.filter(
    network =>
      !checkIfNetworkIdDisabledToAdd(network.chainId) ||
      network.chainId === Number(DEFAULT_NETWORK_ID),
  ).map(network => {
    if (isFakeCardanoChainId(network.chainId)) {
      return {
        ...network,
        name: WRAPPED_MILKOMEDA_CARDANO_NETWORK_NAME,
        shortName: WRAPPED_MILKOMEDA_CARDANO_NETWORK_NAME,
      };
    }
    return network;
  });
});
const getName = value => networkListOptions.value.find(item => item.chainId === value)?.name;
const getIconPath = value =>
  networkListOptions.value.find(item => item.chainId === value)?.iconLink;

const onChange = event => {
  emits('onChange', event);
};
const onHide = () => {
  emits('onHide');
};
onMounted(() => {
  selectedNetwork.value = props.defaultChainId ? +props.defaultChainId : +DEFAULT_NETWORK_ID!;
});

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (!__props.isReadonly)
    ? (_openBlock(), _createBlock(_component_Dropdown, {
        key: 0,
        ref_key: "netsDropdown",
        ref: netsDropdown,
        modelValue: selectedNetwork.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedNetwork).value = $event)),
        options: _unref(networkListOptions),
        "option-label": "name",
        "option-value": "chainId",
        class: _normalizeClass(__props.buttonText ? 'dropdown-button-text' : 'dropdown-button'),
        "panel-class": "dropdown-list mt-s1",
        onChange: _cache[1] || (_cache[1] = ($event: any) => (onChange($event))),
        onHide: onHide
      }, {
        value: _withCtx((slotProps) => [
          _createElementVNode("div", _hoisted_1, [
            (!__props.buttonText)
              ? (_openBlock(), _createBlock(TokenIcon, {
                  key: 0,
                  "icon-src": getIconPath(slotProps.value),
                  class: "mr-s1",
                  size: "20"
                }, null, 8, ["icon-src"]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(getName(selectedNetwork.value)), 1)
          ])
        ]),
        option: _withCtx((slotProps) => [
          _createVNode(TokenIcon, {
            "icon-src": slotProps.option.iconLink,
            class: "mr-s1",
            size: "20"
          }, null, 8, ["icon-src"]),
          _createTextVNode(" " + _toDisplayString(slotProps.option.name), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "class"]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(__props.buttonText ? 'dropdown-button-text' : 'dropdown-button'),
        readonly: ""
      }, [
        (!__props.buttonText)
          ? (_openBlock(), _createBlock(TokenIcon, {
              key: 0,
              "icon-src": getIconPath(selectedNetwork.value),
              class: "mr-s1",
              size: "20"
            }, null, 8, ["icon-src"]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(getName(selectedNetwork.value)), 1)
      ], 2))
}
}

})